import { lazyNamed } from 'src/utils/lazyNamed';

export const Products = {
  List: lazyNamed(() => import('./containers/ProductsList'), 'ProductsList'),
  Form: lazyNamed(() => import('./containers/ProductForm'), 'ProductForm'),
  ProductHistory: lazyNamed(() => import('./containers/ProductHistory'), 'ProductHistory'),
};
